import React, { useState } from 'react'
import Sidebar from '../../Components/Sidebar'
import Header from '../../Components/Header'
import Select from 'react-select';
import Datetime from 'react-datetime';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.css'
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css'
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import useAxiosFile from "../../actions/useaxios";
import { DateTimeForm, isEmpty } from '../../actions/common';
import config from '../../../src/actions/config'

function Reviews() {

  const { toggle, payload, token } = useSelector((state) => state.seller_panel.User)


  const [shoplist, SetShopList] = useState([]);
  const [currentShop, SetCurrentShop] = useState({ label: "", value: "" });
  const [Reviews, SetReviews] = useState([]);
  const [selectReviews, SetselectReviews] = useState({});
  const [Typechange, SetTypechange] = useState({ label: 'Shop', value: 'Shop' },);



  const axiosFile = useAxiosFile();
  const Type = [
    { label: 'Shop', value: 'Shop' },
    { label: 'Product', value: 'Product' },


  ]

  useEffect(() => {
    if (payload?._id) {
      GetShoplist();
    }
  }, [payload?._id])


  const GetShoplist = async () => {
    let Resp = await axiosFile.getshop({ SellerId: payload._id });
    SetShopList(Resp?.data);
    if (Resp?.data?.length > 0) {
      SetCurrentShop({
        label: Resp?.data[0]?.label,
        value: Resp?.data[0]?.value,
      });
    }
  };
  const ShopChange = (e) => {
    if (e?.value) {
      SetCurrentShop({ label: e.label, value: e.value });
    }
  };
  useEffect(() => {
    if (currentShop?.value) {
      GetReviewList();
    }
  }, [currentShop?.value, Typechange]);

  const GetReviewList = async () => {
    let senddata = {
      SellerId: payload?._id,
      ShopId: currentShop?.value,
      Type: Typechange?.value
    }
    let Resp = await axiosFile.getReviews(senddata)
    console.log('GetReviewList_resp', Resp)
    SetReviews(Resp?.data)

  }



  const columns = [
    {
      dataField: "today", text: <p className='reviewtbl_blurblueth'>Profile</p>,
      formatter: (cell, row) => (
        <>
          <img
            className="tab_dummyimg"
            src={
              isEmpty(row?.UserId?.Profile)
                ? require('../../assets/images/tablefood.png')
                : `${config.IMG_URL}/user/${row?.UserId?._id}/Profile/${row?.UserId?.Profile}`
            }
            alt='dummyimg'
          />
          <p>
          </p>
        </>
      ),
    },


    {
      dataField: "Ratings",
      text: "Ratings",
      sort: false,
      formatter: (cell, row) => (
        <div className='reviewtbl_cust_dtls'>
          <p className='table_blurblue weight_blurblue m-0'>{row?.Rating}</p>
          <img className='ms-1' src={require('../../assets/images/Star.png')} alt='start' /></div>
      ),
    },
    {
      dataField: "User",
      text: "User",
      sort: false,
      formatter: (cell, row) => (
        <div className='reviewtbl_cust_dtls'>
          {console.log('rowrow', row)}
          <p className='table_blurblue weight_blurblue m-0'>{row?.UserId?.FirstName + row?.UserId.LastName}</p>
        </div>
      ),
    },
    {
      dataField: "Comments",
      text: "Comments",
      sort: false,
    },
    {
      dataField: "Date",
      text: "Date",
      sort: false,
      formatter: (cell, row) => (
        <p className='table_blurblue weight_blurblue m-0'>{DateTimeForm(row?.createdAt, false, false, true)}</p>
      ),
    },
    {
      dataField: "View",
      text: "View",
      sort: false,
      formatter: (cell, row) => (
        <button className="table_grnavtivebtn" onClick={() => SetselectReviews(row)}>
          <span>View</span>
        </button>
      ),
    },

  ]


  const stylesgraybg = {
    option: (styles, { isFocused, isSelected, isHovered }) => ({
      ...styles,
      color: "#6C6A81",
      background: isFocused ? "#F5F6F7" : isSelected ? "#F5F6F7" : isHovered ? "red" : "#F5F6F7",

      zIndex: 1,
      cursor: "pointer",
      fontSize: "13px"
    }),

    option: (styles, { isFocused, isSelected, isHovered }) => {
      // const color = chroma(data.color);


      return {
        ...styles,
        backgroundColor: isHovered ? "#06038D" : isSelected ? "#06038D" : isFocused ? "#06038D" : "",
        cursor: "pointer",
        color: isHovered ? "#fff" : isSelected ? "#fff" : isFocused ? "#fff" : "",
        fontSize: "13px"

      };
    },
    valueContainer: (provided, state) => ({
      ...provided,
      height: "40px",
      padding: "0 20px",
      backgroundColor: "#fff ",
      //   border: "1px solid rgba(34, 34, 34, 0.32)",
      borderRadius: 10,
      fontSize: "13px"


    }),
    control: (provided, state) => ({
      ...provided,
      height: "40px",
      borderRadius: 10,
      backgroundColor: "#fff",
      border: "none",
      outline: "none",
      boxShadow: "none"

    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "40px",
      position: "absolute",
      right: 0,
      top: 0,
      color: "#6C6A81",

    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: "#6C6A81",

    }),
    menuList: (base) => ({
      ...base,
      // kill the white space on first and last option
      padding: 0,
    }),
  };


  return (
    <section id="content-wrapper" className='mintblue_bg mt-3'>
      <div className='sec_border review_secborder'>
        <div className='row'>

          <div className='col-lg-8'>
            <div className='top_title_sec review_topttl justify-content-end gap-2'>
              {/* <div>
                              <div className='whole_searchbar white_bg'>
                                <img className='search_glass' src={require('../../assets/images/icons/Search.png')} alt='search' />
                                <input placeholder="Search..." />
                              </div>
                            </div> */}
              <div className='rightside'>
                <div className='rightside_select'>
                  <Select
                    options={shoplist}
                    styles={stylesgraybg}
                    onChange={(e) => {
                      ShopChange(e);
                    }}
                    className="border_blue_select"
                    classNamePrefix="react-select"
                    placeholder='All'
                    value={currentShop}

                  />
                </div>

              </div>
              <div className='rightside'>
                <div className='rightside_select'>
                  <Select
                    options={Type}
                    styles={stylesgraybg}
                    onChange={(e) => {
                      SetTypechange(e)
                    }}
                    className="border_blue_select"
                    classNamePrefix="react-select"
                    placeholder='All'
                    value={Typechange}

                  />
                </div>

              </div>
            </div>

                          {Reviews?.length > 0 ?
                            <div className='ffd_table review_firsttable m-0'>
                              <BootstrapTable bootstrap4 keyField='id' columns={columns} data={Reviews} noDataIndication="No data found" />
                            </div>
                            :
                            <p className='text-center mt-5'>No Data Found</p>
                          }
                          {/* <div className='ffd_table review_firsttable m-0'>
          <BootstrapTable bootstrap4 keyField='id' columns={yesterdaycolumn} data={yesterdaydata}/>
          </div> */}
          </div>


          <div className='col-lg-4'>

            {!isEmpty(selectReviews) ?
              <>
                <div className='top_title_sec review_topttl'>
                  <div>
                    <div className='reviewtbl_cust_dtls'><img className='reviewtbl_cust_img' src={
                      isEmpty(selectReviews?.UserId?.Profile)
                        ? require('../../assets/images/tablefood.png')
                        : `${config.IMG_URL}/user/${selectReviews?.UserId?._id}/Profile/${selectReviews?.UserId?.Profile}`
                    } alt='tablefood' /><p className='reviewbtl_cusname'>{selectReviews?.UserId?.FirstName + selectReviews?.UserId.LastName}</p></div>
                  </div>
                  <div className='rightside'>
                    {/* <img src={require('../../assets/images/icons/threedots.png')} alt='threedots' /> */}


                  </div>
                </div>

                <div className='review_rightdtls_content'>
                  <div className='review_rightdtls_whole'>
                    <div className='review_single_idprice d-block'>
                      <p className='review_singleid'>{selectReviews?.OrderId?.OrderNumber}</p>
                      <p className='review_singleprice'>${selectReviews?.OrderId?.Price?.PayAmount}</p>
                    </div>
                    <p className='review_datetxt'>{DateTimeForm(selectReviews?.createdAt, false, false, true)}</p>
                    <div className='reviewtbl_cust_dtls mt-3'><p className='table_blue weight_blurblue m-0'>{selectReviews?.Rating}</p><img className='ms-1' src={require('../../assets/images/Star.png')} alt='star' /></div>

                    <p className='review_datetxt'>{selectReviews?.Comments}</p>

                  </div>
                </div>
              </>
              :
              <p className='text-center mt-5'>No Data Found</p>
            }
          </div>


        </div>
      </div>


    </section>
  )
}

export default Reviews